import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';
import { Space } from '../../space';
import { Text } from '../../typography';

export type FormSectionProperties = PropsWithChildren<{
  title: { icon?: ReactNode } & ComponentProps<typeof Text>;
}>;

const FormSection = ({ children, title: { children: titleChildren, icon, ...title } }: FormSectionProperties) => (
  <Space block orientation="vertical" size="medium">
    <Text size="large" type="title" weight="medium" {...title}>
      <Space block orientation="horizontal" size="xxs">
        {icon}
        {titleChildren}
      </Space>
    </Text>
    <div>{children}</div>
  </Space>
);

export default FormSection;
